import type { AxiosError } from 'axios';
import { mapOtpErrorCodeToMessage } from 'src/components/AuthNew/errors';
import { api } from 'src/api';
import type { PostClientConfirmPhone } from '@lt/api/dist/methods/client/types';
import { get, head } from 'lodash';
import { RequestStatus } from '../types';

type Props = {
  onSendSmsCodeAgain(): void;
  setRequestStatus: (type: RequestStatus) => void;
  onSuccessConfirmPhone: () => void;
};

export const useConfirmPhone = ({
  onSendSmsCodeAgain,
  onSuccessConfirmPhone,
  setRequestStatus,
}: Props) => {
  const handleOtpError = (error: AxiosError) => {
    const errorCode: any = head(get(error, ['response', 'data', 'errors']));
    const attemptsLeft = error?.response?.data?.error?.attempts_left;
    if (errorCode === 'otp_expired') {
      onSendSmsCodeAgain();
    } else {
      throw new Error(mapOtpErrorCodeToMessage(errorCode, attemptsLeft));
    }
  };

  const handleConfirmPhone = async (
    data: PostClientConfirmPhone,
  ): Promise<void> => {
    try {
      setRequestStatus(RequestStatus.Submitting);
      const { success } = await api.postClientConfirmPhone(data);
      if (!success) {
        setRequestStatus(RequestStatus.Failed);
        return;
      }
      setRequestStatus(RequestStatus.Succeeded);
      onSuccessConfirmPhone();
    } catch (e: any) {
      setRequestStatus(RequestStatus.Failed);
      console.dir(e);
      handleOtpError(e);
    }
  };

  return {
    handleOtpError,
    handleConfirmPhone,
  };
};
